import { HTMLAttributes, ReactNode } from 'react';
import { Typography, tailwindOverride } from '@getsynapse/design-system';

type PageTitleProps = {
  headerChildren?: ReactNode;
  titleComponent: ReactNode;
  dataCy?: string;
  titleVariant?: string;
  titleClassName?: string;
} & HTMLAttributes<HTMLDivElement>;

const PageTitle = ({
  headerChildren,
  className,
  titleComponent,
  titleVariant,
  dataCy,
  titleClassName,
  ...otherProps
}: PageTitleProps) => {
  return (
    <div
      className={tailwindOverride(
        'flex justify-between min-h-14 max-h-14',
        'items-center px-6 pt-2 pb-4 bg-neutral-white z-5',
        className
      )}
      {...otherProps}
    >
      <Typography
        variant={titleVariant || 'h4'}
        weight='medium'
        className={tailwindOverride('text-neutral-black', titleClassName)}
        data-cy={dataCy}
      >
        {titleComponent}
      </Typography>
      {headerChildren}
    </div>
  );
};

export default PageTitle;
